import { HStack } from "native-base";
import React, { createRef, useEffect } from "react";
import { StyleSheet, View } from "react-native";
import { BRANDING } from "../../assets/consts";
import { faInfoCircle } from "../../assets/consts/faCharCodes";
import Theme from "../argon-ui/Theme";
import { translate } from "../locales/translate";
import InputBase from "../nativeBase-ui/InputBase";
import FontAwesomeIcon from "./FontAwesomeIcon";
import Text from "./TextFont";
import { getDir, getIsRTL } from "../util";
const SAMPLE_REGISTER_CODE = "ABC1234";
const CODE_PREFIX = BRANDING.CODE_PREFIX;
type Props = {
  codeLetter: string;
  steCodeLetter: any;
  codeDigi: string;
  setCodeDigi: any;
  formValidityData: any;
  setFormValidityData: any;
  callbackRegister?: () => void;
};

const RegisterBuildingInput = (props: Props) => {
  const codeDigiInputRef = createRef<any>();
  const {
    codeDigi,
    setCodeDigi,
    codeLetter,
    steCodeLetter,
    formValidityData,
    setFormValidityData,
    callbackRegister,
  } = props;

  // === render error message ===
  const renderErrorMessage = (errorMessage: string) => {
    return (
      <View
        style={{
          alignItems: "center",
          flexDirection: "row",
          marginTop: 10,
        }}
      >
        <FontAwesomeIcon
          style={{ paddingHorizontal: 4 }}
          icon={faInfoCircle}
          size={15}
          color={Theme.COLORS.ERROR}
        />

        <Text style={{ color: Theme.COLORS.ERROR, fontSize: 11 }}>
          {errorMessage}
        </Text>
      </View>
    );
  };
  const onCodeLetterHandler = (value: string) => {
    steCodeLetter(value);
  };
  // === Callback setCodeLetter ===
  useEffect(() => {
    if (codeLetter.length === 3) {
      codeDigiInputRef.current?.focus();
    }
  }, [codeLetter]);
  // === Callback setCodeDigi ===
  useEffect(() => {
    if (codeDigi.length === 4) {
      typeof callbackRegister === "function" && callbackRegister();
    }
  }, [codeDigi]);

  return (
    <>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          marginTop: 5,
        }}
      >
        <Text
          Text
          style={{
            color: Theme.COLORS.GRAY_DARK,
            fontSize: 13,
            paddingRight: 10,
          }}
        >
          {translate("building.registerCode")}
        </Text>
      </View>
      <View>
        <HStack
          // style={{
          //   width: "100%",
          //   flexDirection: IS_WEB ? "row" : "row-reverse",
          //   alignItems: "center",
          //   justifyContent: "space-between",
          //   marginVertical: 5,
          // }}
          space="2"
          w="100%"
          alignItems="center"
          justifyContent="space-between"
          flexDirection="row"
          mt="1"
        >
          {/* === code Prefix === */}
          <View style={style.codePrefixContainer}>
            <Text style={{ fontSize: 18 }}>{CODE_PREFIX}</Text>
          </View>
          <Text style={{ fontSize: 18 }}>-</Text>
          {/* === code Letter === */}
          <InputBase
            containerStyle={{ flex: 1 }}
            inputStyle={{ textAlign: "left" }}
            placeholder="ABC"
            maxLength={3}
            onChangeText={(txt: string) => onCodeLetterHandler(txt)}
            value={codeLetter?.toLocaleUpperCase()}
            onBlur={() =>
              setFormValidityData({
                type: "VALIDATE_CODE_LETTER",
                payLoad: codeLetter,
              })
            }
            isInvalid={formValidityData.codeLetterError}
          />
          <Text style={{ fontSize: 18 }}>-</Text>
          {/* === code Digi === */}
          <InputBase
            ref={codeDigiInputRef}
            containerStyle={{ flex: 1 }}
            inputStyle={{ textAlign: "left", fontFamily: "sans-serif" }}
            placeholder="1234"
            maxLength={4}
            keyboardType="numeric"
            onChangeText={(txt: string) => setCodeDigi(txt)}
            value={codeDigi}
            onBlur={() =>
              setFormValidityData({
                type: "VALIDATE_CODE_DIGI",
                payLoad: codeDigi,
              })
            }
            isInvalid={formValidityData.codeDigiError}
          />
        </HStack>
        <HStack space="1" alignItems="center" style={{ direction: getDir() }}>
          <Text
            style={{
              fontSize: 11,
              color: Theme.COLORS.GRAY_DARK,
            }}
          >
            {translate("app.forExample")}
          </Text>
          <Text
            style={{
              fontSize: 11,
              color: Theme.COLORS.GRAY_DARK,
              fontFamily: "sans-serif",
            }}
          >
            {SAMPLE_REGISTER_CODE}
          </Text>
        </HStack>
      </View>

      {/* === render code error validation === */}
      {formValidityData.codeLetterErrorMessage !== "" &&
        renderErrorMessage(formValidityData.codeLetterErrorMessage)}
      {formValidityData.codeDigiErrorMessage !== "" &&
        renderErrorMessage(formValidityData.codeDigiErrorMessage)}
    </>
  );
};

export default RegisterBuildingInput;

const style = StyleSheet.create({
  codePrefixContainer: {
    justifyContent: "center",
    alignItems: "center",
    height: 45,
    borderRadius: 5,
    padding: 10,
    backgroundColor: Theme.COLORS.BORDER_COLOR,
  },
});
